export const createCartPopup = (productId, variationId = 0) => {
  const instance = {
    $element: null,

    init: async function (productId, variationId) {
      await this.fetchHtml(productId, variationId);
      this.show();
    },

    async fetchHtml(productId, variationId) {
      try {
        const response = await jQuery.get(hs.ajaxUrl, {
          action: "hs_get_cart_popup_html",
          product_id: productId,
          variation_id: variationId,
        });

        if (response.success) {
          jQuery("body").append(response.data.html);

          // Now that we have the element, we can initialize it
          this.$element = jQuery("[data-component='cart-popup']");
          this.$element.attr("data-initialized", true);
          this.setupPopupEventListeners();
          return true;
        }
      } catch (error) {
        console.error("Error showing cart popup:", error);
        throw error;
      }
    },

    show() {
      if (this.$element) {
        this.$element.show();
      }
    },

    setupPopupEventListeners() {
      if (this.$element) {
        this.$element.on("click", (e) => {
          if (!jQuery(e.target).closest(".js-cart-popup-inner").length) {
            this.close();
          }
        });
        this.$element.on("click", ".js-cart-popup-close", (e) => {
          e.preventDefault();
          this.close();
        });
      }
    },

    removePopupEventListeners() {
      jQuery(document).off(".cartPopup");
    },

    close() {
      this.removePopupEventListeners();
      if (this.$element) {
        this.$element.remove();
      }
    },
  };

  instance.init(productId, variationId);
  return instance;
};
